import React from 'react';
import shoppingCartIcon from '../../assets/images/shopping-cart.png';
import ProductStatus from '../ProductStatus';
import OrderAvailabilityBadges from '../OrderAvailabilityBadges';
import BasketSummary from './BasketSummary';
import { MAX_QUANTITY_TOOLTIP, formatPrice, renderTotalPrice } from './basketUtils';
import ProductAvailabilityNote from '../ProductAvailabilityNote';
import ProductPhoto from '../ProductPhoto';

const BasketMobile = ({
  products,
  onChangeQuantity,
  removeProductFromCart,
  close,
  allowToOrder = false,
}) => {
  const isEmpty = products.length === 0;

  return (
    <>
      <div className="modal-header basket-modal-header">
        <h4
          id="basket-title"
          className="modal-title w-100 text-center m-0 d-flex justify-content-center align-items-center basket-header-title"
          style={{ fontWeight: 600 }}
        >
          <img
            src={shoppingCartIcon}
            alt=""
            className="basket-header-icon"
            style={{ width: '22px', height: '22px', marginRight: '6px', flexShrink: 0 }}
          />
          <span>Кошик товарів</span>
        </h4>
        <button
          type="button"
          className="close"
          aria-label="Закрити"
          onClick={close}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div className="modal-body basket-modal-body">
        <div className="container basket-modal-container">
          {products.length === 0 ? (
            <div className="py-2 text-center">
              <p className="mb-0 font-weight-bold">Кошик пустий</p>
            </div>
          ) : (
      products.map((product, index) => {
        const { quantity } = product;
        const showMaxQtyTooltip = product.showTooltip;
        const isLast = index === products.length - 1;
        return (
          <div key={product.id + product.name} className={isLast ? 'pb-2' : 'border-bottom pb-2 mb-2'}>
            <div className="row no-gutters">
              <div className="col-auto">
                <ProductPhoto image={product.image} name={product.name} price={product.price}
                  personalDiscount={product.personalDiscount} productDiscount={product.productDiscount}
                  discountedPrice={product.discountedPrice} className='cartImage' />
              </div>
              <div className="col d-flex align-items-center pl-2" style={{ minWidth: 0 }}>
                <h6 className="m-0" style={{ fontWeight: 600, overflowWrap: 'anywhere' }}>{product.name}</h6>
              </div>
              <div className="col-12">
                {allowToOrder ? <OrderAvailabilityBadges product={product} /> : <ProductStatus product={product} isBasket />}
                {product.maxQuantity > 0 && product.maxQuantity <= 3 &&
                  <ProductAvailabilityNote kind='low-stock' quantity={product.maxQuantity} productId={product.id} />}
              </div>
              <div className="col-12 pt-2 d-flex align-items-center" style={{ fontSize: '1rem', fontWeight: 400 }}>
                {product.discountedPrice !== product.price ? (
                  <>
                    <span style={{ color: '#999', textDecoration: 'line-through', marginRight: '8px' }}>
                      {formatPrice(product.price)} грн
                    </span>
                    <span>{formatPrice(product.discountedPrice)} грн</span>
                  </>
                ) : (
                  <span>{formatPrice(product.discountedPrice)} грн</span>
                )}
              </div>
              <div className="col-12 d-flex align-items-center justify-content-between pt-2 mb-2">
                <div style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #dee2e6', borderRadius: '6px', overflow: 'visible' }}>
                  <span
                    onClick={() => onChangeQuantity(false, product.id)}
                    style={{ cursor: 'pointer', padding: '4px 10px', color: '#6c757d', fontSize: '1rem' }}
                    role="button"
                    tabIndex={0}
                  >
                    -
                  </span>
                  <span style={{ padding: '4px 12px', minWidth: '28px', textAlign: 'center', fontSize: '1rem' }}>
                    {quantity} шт
                  </span>
                  <span className="basket-quantity-plus-wrapper">
                    {showMaxQtyTooltip && (
                      <div className="basket-max-qty-tooltip" role="tooltip">
                        <strong>{MAX_QUANTITY_TOOLTIP}</strong>
                      </div>
                    )}
                    <span
                      onClick={() => onChangeQuantity(true, product.id)}
                      style={{ cursor: 'pointer', padding: '4px 10px', color: '#6c757d', fontSize: '1rem' }}
                      role="button"
                      tabIndex={0}
                    >
                      +
                    </span>
                  </span>
                </div>
                <span style={{ whiteSpace: 'nowrap' }}>{renderTotalPrice(product)}</span>
                <span
                  role="button"
                  tabIndex={0}
                  className="cart-delete-btn flex-shrink-0"
                  onClick={() => removeProductFromCart(product.id)}
                  onKeyDown={(e) => e.key === 'Enter' && removeProductFromCart(product.id)}
                  style={{ cursor: 'pointer', padding: '4px' }}
                  aria-label="Видалити товар з кошику"
                >
                  <i className="bi bi-trash-fill cart-delete-icon" style={{ fontSize: '1.25rem' }} />
                </span>
              </div>
            </div>
          </div>
        );
      })
          )}
        </div>
      </div>

      <div className="modal-footer basket-modal-footer py-2 px-3">
        <div className="container p-0 basket-modal-container">
          <div className="text-right">
            {!isEmpty && <BasketSummary products={products} />}
            <div className={`basket-footer-buttons ${isEmpty ? 'text-center' : ''}`} style={{ marginTop: isEmpty ? 0 : '12px' }}>
              {!isEmpty && <a className="btn btn-dark btn-block mb-2" href="/checkout">Перейти до оформлення</a>}
              <button type="button" className={`btn btn-outline-secondary ${isEmpty ? '' : 'btn-block'}`} onClick={() => close()}>
                <i className="bi bi-arrow-left mr-1" />
                Повернутись до покупок
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default BasketMobile;
